module.exports = __webpack_public_path__ + "img/video3.952e8556.png";